export default "__VITE_ASSET__3yA6uD7S__"